export const TOAST_TYPES = {
  DEFAULT: null,
  DANGER: 'danger',
  LOADING: 'loading',
};
